// extracted by mini-css-extract-plugin
module.exports = {"phoneIcon":"_42e3njuIEgylUCZDJipT2g=="};